import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as _ from "underscore";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  setHelperText,
  CheckActionPermission,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import leaveTypeImg from "../../../../../Assets/Images/departing.svg";
import CustomLoader from "Component/CustomLoader";


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});
const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px dashed rgb(102, 102, 102)",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
  borderWidth: 2,
};

class LeavePlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actionidlist: "",
      plan: [],
      loading: false,
      permissions: { readOnly: false, editable: false },
    };
  }

  componentWillMount() {
    this.props.ChangeLanguage("leaveplan");
  }

  componentDidMount() {
    this.props.setHelperText({
      helperText: "Helper text for Leave Plan",
      open: false,
    });

    const [isTrue, permissions] = CheckActionPermission("leavePlan");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getMasterCAtegories();
      });
    } else {
      // this.props.history.push('404')
      this.setState({ permissiondenied: true });
    }
  }

  showLoader() {
    return  <div><CustomLoader /></div>;
  }

  getMasterCAtegories() {
    this.setState({ loading: true }, () =>
      instance
        .get("/leaves/masterandsubleavetype")
        .then((result) => {
          let plan = [];
          const subscriptionplanids = [];
          result.data.result.length > 0
            ? (plan = result.data.result)
            : (plan = []);

          this.setState({ plan });
          _.each(plan, (value, key) => {
            // if (value.subscriptionplanid != 0)
            subscriptionplanids.push(value.subscriptionplanid);
          });
          this.setState({ loading: false });

          if (subscriptionplanids.length <= 0) {
            // this.rendertoForm();
          } else {
            this.props.history.push({
              pathname: "./form",
              state: { permissions: this.state.permissions },
            });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        }),
    );
  }

  rendertoForm() {}

  CreatePlan(e) {
    this.props.history.push({
      pathname: "./form",
      state: { permissions: this.state.permissions },
    });

    // let employeeLink = `http://${window.location.hostname}:${this.state.port}/subscription/configurecycle`;
    // window.open(employeeLink, "_blank");
  }

  render() {
    const language = this.props.Language.leaveplan;
    return (
      <IntlProvider locale="en" messages={language}>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div className="innerwrapper-full-width">
            {this.state.loading == true ? (
              this.showLoader()
            ) : (
              <React.Fragment>
                <div className={`innerwrapperheader2`}>
                  <div className="innerwrapper-page-header">
                    Leave / Leave Type
                  </div>
                </div>

                <Divider light />
                {this.state.plan.length < 1 && (
                  <Grid
                    container
                    style={{ paddingLeft: 80, paddingTop: 80 }}
                    className=""
                  >
                    <Grid item xs={12} md={6} sm={12}>
                      <h5 style={{ fontSize: "1.3125rem" }}>
                        <FormattedMessage
                          id="LbPlanHeading"
                          defaultMessage="Concept of Leave Plan"
                        />
                      </h5>
                      <p
                        className="cycle-desc"
                        style={{ height: "unset" }}
                        tabIndex="0"
                      >
                        <span
                          style={{ display: "block", textAlign: "justify" }}
                        >
                          <FormattedMessage
                            id="leaveTypeConcept"
                            defaultMessage="Here you can choose which type of Leaves you'd like to use in your company. You may choose a larger set of options here, and then narrow them down when defining the policy."
                          />
                          <FormattedMessage
                            id="leaveTypeConceptSub"
                            defaultMessage="While enabling your choice of leaves, don't worry about whether all employees will get those leaves or not - as the Leave Policy feature will allow you to control which employee gets which leave, and how many of it."
                          />
                        </span>
                      </p>

                      {this.state.permissions.editable ? (
                        <Button
                          variant="contained"
                          tabIndex="1"
                          color="primary"
                          onClick={this.CreatePlan.bind(this)}
                          className="createbutton"
                        >
                          <FormattedMessage
                            id="BtCreatePlan"
                            defaultMessage="CREATE"
                          />
                        </Button>
                      ) : (
                        ""
                      )}
                      {/* <span className=" form-btn-helptxt-menulist"><FormattedMessage id="LbPressEnter" defaultMessage="Press Enter, Tab or Arrow Keys" /></span> */}
                    </Grid>
                    <Grid item xs={12} md={6} sm={12} align="center">
                      <img src={leaveTypeImg} className="width80" />
                    </Grid>
                  </Grid>
                )}
              </React.Fragment>
            )}
          </div>
        )}
      </IntlProvider>
    );
  }
}

LeavePlan.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(LeavePlan)));
